import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import {
  DialogEmailTypeEnum,
  IEmailTemplateCard,
  IEmailTemplateInfo,
  ITemplatePayload
} from 'src/app/models/email';
import { IGenericResult } from 'src/app/models/generic';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  baseUrl = `${environment.apis.notification.baseUrl}/${environment.apis.notification.microservices.template}`;

  constructor(private _http: HttpClient) {}

  getEmailTemplateList(): Observable<any> {
    const params = {
      skip: '0',
      take: '20'
    };

    const paramsTransfer = {
      eventType: 'Transfer',
      ...params
    };

    const paramsInvoice = {
      eventType: 'Invoice',
      ...params
    };

    return combineLatest([
      this._http.get<IGenericResult<IEmailTemplateInfo[]>>(`${this.baseUrl}`, {
        params: paramsTransfer
      }),
      this._http.get<IGenericResult<IEmailTemplateInfo[]>>(`${this.baseUrl}`, {
        params: paramsInvoice
      })
    ]);
  }

  getTemplateById(id: string): Observable<IGenericResult<IEmailTemplateInfo>> {
    return this._http.get<IGenericResult<IEmailTemplateInfo>>(
      `${this.baseUrl}/${id}`
    );
  }

  getTemplateVariables({
    eventType,
    eventName
  }: {
    eventType: string;
    eventName: string;
  }): Observable<ITemplatePayload[]> {
    const params = {
      eventType,
      eventName
    };

    return this._http.get<ITemplatePayload[]>(`${this.baseUrl}/payload`, {
      params
    });
  }

  createTemplate(template: IEmailTemplateInfo): Observable<IGenericResult<IEmailTemplateInfo>> {
    return this._http.post<IGenericResult<IEmailTemplateInfo>>(`${this.baseUrl}/`, template);
  }

  updateTemplate(template: IEmailTemplateInfo): Observable<any> {
    return this._http.put(`${this.baseUrl}/${template.TemplateId}`, template);
  }

  deleteTemplate(id: string): Observable<any> {
    return this._http.delete(`${this.baseUrl}/${id}`);
  }
}
